import {
  CheckIcon,
  CopyIcon,
  IconButton,
  type IconButtonProps,
  Tooltip,
  useClipboard,
} from "@hightouch/htui";
import type { FC } from "react";

type Props = {
  value: string;
  variant?: IconButtonProps["variant"];
  tooltip?: string;
  size?: IconButtonProps["size"];
};

export const CopyButton: FC<Readonly<Props>> = ({
  value,
  variant,
  tooltip = "Copy",
  size = "md",
}) => {
  const clipboard = useClipboard(value);
  return (
    <Tooltip
      message={clipboard.hasCopied ? "Copied!" : tooltip}
      placement="bottom"
    >
      <IconButton
        aria-label="Copy message"
        icon={clipboard.hasCopied ? CheckIcon : CopyIcon}
        size={size}
        variant={variant}
        onClick={() => {
          clipboard.onCopy();
        }}
      />
    </Tooltip>
  );
};
